
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1920',
  depVersions: {
  "customer-portal-app": "static-1.1920",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9566",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.425",
  "growth-payments-core": "static-1.25015",
  "head-dlb": "static-1.4921",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5485",
  "hs-test-utils": "static-1.7902",
  "hub-http": "static-1.6109",
  "hub-http-shared-msw-handlers": "static-1.9706",
  "hubspot-dlb": "static-2.1828",
  "hubspot-prosemirror": "static-1.17900",
  "hubspot-url-utils": "static-1.4034",
  "HubStyleTokens": "static-2.11339",
  "I18n": "static-7.1598",
  "immutable": "static-2.76",
  "jasmine-runner": "static-1.6360",
  "payment-link-components": "static-1.23203",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6853",
  "quartz-core": "static-1.6072",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10100",
  "react-dlb": "static-1.76",
  "react-utils": "static-2.5257",
  "rich-text-lib": "static-1.19640",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17819",
  "ui-components-test-utils": "static-1.5477",
  "UIComponents": "static-3.8286",
  "foundations-assets": "static-1.4735",
  "foundations-components": "static-1.7700",
  "foundations-theming": "static-1.4302",
  "foundations-theming-specialty": "static-1.2018",
  "framer-motion": "static-1.70",
  "history": "static-4.47",
  "metrics-js": "static-1.9522",
  "PortalIdParser": "static-2.386",
  "portals-platform-lib": "static-1.682",
  "quartz-config": "static-1.631",
  "quartz-routing": "static-1.283",
  "quick-fetch": "static-1.3824",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16544",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8035",
  "styled-components": "static-2.87",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4659",
  "ui-addon-react-router-dom": "static-1.9435",
  "usage-tracker": "static-1.7226",
  "usage-tracker-anonymous": "static-1.5643",
  "usage-tracker-core": "static-1.7076",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3315",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3130",
  "quartz-webpack": "static-1.3077",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7545",
  "frontend-preferences-client": "static-1.7814",
  "laboratory-lib": "static-3.7050",
  "onboarding-scopes": "static-1.6353",
  "rpc-client-utils": "static-1.4534",
  "ui-addon-opt": "static-4.8273",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3013",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.3988",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7586",
  "cssUtils": "static-1.764",
  "customer-data-ui-utilities": "static-1.9715",
  "HubStyle": "static-2.11647",
  "knowledge-content-types": "static-1.8438",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.528",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9777",
  "ui-addon-i18n": "static-1.11037",
  "ui-business-units-lib": "static-1.8930",
  "ui-shepherd-react": "static-3.10037",
  "video-components-external": "static-1.10897",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4215",
  "commerce-tours-lib": "static-1.5889",
  "customer-data-properties": "static-1.51133",
  "getting-started-shared-tasks": "static-1.18165",
  "growth-onboarding-reliability": "static-1.4977",
  "onboarding-tours": "static-1.16398",
  "reference-resolvers-lite": "static-1.7980",
  "sales-checkout-service-client": "static-1.3559",
  "ui-addon-iframeable": "static-1.8940",
  "user-context": "static-1.4990",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4561",
  "icons": "static-2.637",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.528",
  "quartz-head": "static-1.518",
  "quartz-test": "static-1.528",
  "quartz-tracking": "static-1.232",
  "ui-fonts": "static-1.601",
  "usage-tracker-container": "static-1.7216",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9319",
  "data-token-picker": "static-1.16210",
  "FileManagerLib": "static-1.38892",
  "property-translator": "static-1.5299",
  "atom": "static-1.4960",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5661",
  "salesImages": "static-1.522",
  "SharedI18nStrings": "static-1.181",
  "foundations-components-test-utils": "static-1.5183",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-components": "static-1.3969",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "trellis-assets": "static-1.1492",
  "bend-plugin-foundations-theming": "static-1.2785",
  "foundations-theming-base": "static-1.3287",
  "stylex": "static-1.30",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5640",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4363",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3056",
  "inbound-db-properties-service-client": "static-1.3755",
  "superstore": "static-1.4659",
  "chirp-fetch": "static-1.1772",
  "feedback-loader": "static-1.29081",
  "ai-components-ui-library": "static-1.8642",
  "ui-addon-video-player": "static-1.8586",
  "ui-coaching-tips": "static-1.28211",
  "sassPrefix": "static-1.153",
  "react-dnd-compat": "static-1.4509",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2384",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8056",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4541",
  "content-media-composition-data-lib": "static-1.11852",
  "content-media-compositions": "static-2.15859",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4043",
  "magpie-lib": "static-1.5484",
  "magpie-types": "static-1.4944",
  "media-bridge-lib": "static-1.18730",
  "video-data-lib": "static-1.34555",
  "commerce-products-lib": "static-1.9117",
  "crm-message-bus": "static-1.42654",
  "growth-data-modal": "static-1.5258",
  "hubspot-apollo-client": "static-1.4769",
  "onboarding-tours-client": "static-1.4612",
  "calling-global-api": "static-1.64058",
  "calling-internal-common": "static-1.31192",
  "calling-lifecycle-internal": "static-1.65440",
  "calling-lifecycle-messages": "static-1.57734",
  "conditional-properties-service-client": "static-1.3707",
  "crm-links": "static-1.6165",
  "customer-data-objects-ui-components": "static-1.12908",
  "customer-data-property-utils": "static-1.7973",
  "external-options-client-types": "static-1.4068",
  "file-manager-components": "static-1.23252",
  "framework-data-schema-resolvers": "static-1.6766",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.26",
  "inbound-db-meta-service-client": "static-1.3499",
  "inbounddb-objects-service-types": "static-1.4132",
  "meetings-icalendar-utils-lib": "static-1.521",
  "multi-currency-client-types": "static-1.3599",
  "object-builder-ui-client": "static-1.48348",
  "pipeline-validation-client-types": "static-1.3874",
  "property-value-citations": "static-1.1747",
  "pulse": "static-1.424",
  "smart-property-lib": "static-1.6382",
  "tiered-pricing": "static-1.994",
  "ui-addon-form-validation": "static-1.10882",
  "growth-onboarding-confetti": "static-1.2962",
  "growth-onboarding-next-action-utils": "static-1.1572",
  "navigation-components": "static-1.17611",
  "onboarding-tours-utils": "static-1.464",
  "ui-shepherd-tracker": "static-1.7418",
  "ui-universal-auth": "static-1.8821",
  "batch-promise": "static-1.1442",
  "navigation-messaging": "static-1.6938",
  "getting-started-shared-tasks-store": "static-1.17283",
  "hubspotter-http-shared-msw-handlers": "static-1.9704",
  "usage-tracker-session-replay": "static-1.4912",
  "audio-components": "static-1.5749",
  "FileManagerCore": "static-1.38751",
  "FileManagerImages": "static-1.36403",
  "video-components": "static-1.12900",
  "foundations-components-legacy": "static-1.725",
  "growth-monetization-service-types": "static-1.4391",
  "nav-client-types": "static-1.2248",
  "purchase-motions-api": "static-1.5664",
  "self-service-api": "static-1.10136",
  "signup-constants": "static-1.18635",
  "signup-ui-url-generator": "static-2.7930",
  "trials-service-types": "static-1.3792",
  "usage-tracker-public": "static-1.7037",
  "chatspot-core": "static-1.20767",
  "ContentUtils": "static-1.67981",
  "copilot-toolkit": "static-1.10807",
  "growth-onboarding-feedback-components": "static-1.6471",
  "reactive-lib": "static-1.614",
  "simple-logging-lib": "static-1.2941",
  "commerce-permissions": "static-1.655",
  "customer-data-tracking": "static-1.6773",
  "products-iframe-lib": "static-1.7605",
  "products-ui-components-shared-msw-handlers": "static-1.10088",
  "onboarding-data-sync-lib": "static-1.1774",
  "hubspot-apollo-cache": "static-1.228",
  "calling-error-reporting": "static-1.31198",
  "shared-worker-versioning": "static-1.10929",
  "calling-usage-tracker": "static-1.6432",
  "voice-sms-access-library": "static-1.551",
  "conversations-skeleton-state": "static-1.7139",
  "location-customization-utils-lib": "static-1.8871",
  "crm-pipelines-api-client-types": "static-1.4052",
  "framework-builder-read-service-client": "static-1.3918",
  "framework-data-schema-quick-fetch": "static-1.6671",
  "persist-promise": "static-1.3599",
  "directed-graph": "static-1.828",
  "event-emitter": "static-1.838",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.16",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9789",
  "fsm": "static-1.3624",
  "policy-lib": "static-1.6673",
  "react-tinymce": "static-1.54905",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9852",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54031",
  "tinymce-plugins": "static-1.57145",
  "tinymce-themes": "static-1.56001",
  "growth-onboarding-next-action-components": "static-1.1600",
  "user-context-client": "static-1.4502",
  "nest": "static-1.112",
  "unified-auth-core-lib": "static-1.616",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4422",
  "video-embed": "static-1.35389",
  "content-icons-ui": "static-1.2196",
  "social-insights-client-types": "static-1.21727",
  "eligibility-engine-service-types": "static-1.3073",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4699",
  "integrations-lib": "static-1.15735",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4154",
  "InboxConnectUtils": "static-4.14490",
  "calling-orchestration-schema": "static-1.35328",
  "crm-record-cards-service-types": "static-1.3519",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4410",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2933",
  "interframe": "static-3.4653",
  "tinymce-data": "static-1.40116",
  "ui-addon-sales-email": "static-1.5102",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12229",
  "layout-dnd-utils": "static-1.11204",
  "react-codemirror": "static-1.10514",
  "ui-brand-identity-lib": "static-1.14698",
  "NamespacedHubStyle": "static-2.8978",
  "outpost": "static-1.4085",
  "flux-actions": "static-1.323",
  "integrations-error-boundary-lib": "static-1.13150",
  "integrations-tracking-lib": "static-1.5486",
  "native-integrations-shared-strings": "static-1.7677",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10264",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.335",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68056",
  "layout-data-lib": "static-1.9529",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2897",
  "advanced-menus-core": "static-1.14956",
  "advanced-menus-lib": "static-1.11920",
  "ExportDialog": "static-6.10280",
  "ui-memberships-settings-lib": "static-1.33720",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14955",
  "simple-menus-lib": "static-1.16472"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1920",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9566",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.425",
  "growth-payments-core": "/growth-payments-core/static-1.25015",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5485",
  "hs-test-utils": "/hs-test-utils/static-1.7902",
  "hub-http": "/hub-http/static-1.6109",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9706",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17900",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyleTokens": "/HubStyleTokens/static-2.11339",
  "I18n": "/I18n/static-7.1598",
  "immutable": "/immutable/static-2.76",
  "jasmine-runner": "/jasmine-runner/static-1.6360",
  "payment-link-components": "/payment-link-components/static-1.23203",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6853",
  "quartz-core": "/quartz-core/static-1.6072",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10100",
  "react-dlb": "/react-dlb/static-1.76",
  "react-utils": "/react-utils/static-2.5257",
  "rich-text-lib": "/rich-text-lib/static-1.19640",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17819",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5477",
  "UIComponents": "/UIComponents/static-3.8286",
  "foundations-assets": "/foundations-assets/static-1.4735",
  "foundations-components": "/foundations-components/static-1.7700",
  "foundations-theming": "/foundations-theming/static-1.4302",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2018",
  "framer-motion": "/framer-motion/static-1.70",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9522",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "portals-platform-lib": "/portals-platform-lib/static-1.682",
  "quartz-config": "/quartz-config/static-1.631",
  "quartz-routing": "/quartz-routing/static-1.283",
  "quick-fetch": "/quick-fetch/static-1.3824",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16544",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8035",
  "styled-components": "/styled-components/static-2.87",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4659",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9435",
  "usage-tracker": "/usage-tracker/static-1.7226",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5643",
  "usage-tracker-core": "/usage-tracker-core/static-1.7076",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3315",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3130",
  "quartz-webpack": "/quartz-webpack/static-1.3077",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7545",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7814",
  "laboratory-lib": "/laboratory-lib/static-3.7050",
  "onboarding-scopes": "/onboarding-scopes/static-1.6353",
  "rpc-client-utils": "/rpc-client-utils/static-1.4534",
  "ui-addon-opt": "/ui-addon-opt/static-4.8273",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3013",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.3988",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7586",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9715",
  "HubStyle": "/HubStyle/static-2.11647",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.528",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9777",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11037",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8930",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10037",
  "video-components-external": "/video-components-external/static-1.10897",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4215",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5889",
  "customer-data-properties": "/customer-data-properties/static-1.51133",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18165",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4977",
  "onboarding-tours": "/onboarding-tours/static-1.16398",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7980",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3559",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8940",
  "user-context": "/user-context/static-1.4990",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4561",
  "icons": "/icons/static-2.637",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.528",
  "quartz-head": "/quartz-head/static-1.518",
  "quartz-test": "/quartz-test/static-1.528",
  "quartz-tracking": "/quartz-tracking/static-1.232",
  "ui-fonts": "/ui-fonts/static-1.601",
  "usage-tracker-container": "/usage-tracker-container/static-1.7216",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9319",
  "data-token-picker": "/data-token-picker/static-1.16210",
  "FileManagerLib": "/FileManagerLib/static-1.38892",
  "property-translator": "/property-translator/static-1.5299",
  "atom": "/atom/static-1.4960",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5661",
  "salesImages": "/salesImages/static-1.522",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5183",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3969",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.1492",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2785",
  "foundations-theming-base": "/foundations-theming-base/static-1.3287",
  "stylex": "/stylex/static-1.30",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5640",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4363",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3056",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3755",
  "superstore": "/superstore/static-1.4659",
  "chirp-fetch": "/chirp-fetch/static-1.1772",
  "feedback-loader": "/feedback-loader/static-1.29081",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8642",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8586",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28211",
  "sassPrefix": "/sassPrefix/static-1.153",
  "react-dnd-compat": "/react-dnd-compat/static-1.4509",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2384",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8056",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4541",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11852",
  "content-media-compositions": "/content-media-compositions/static-2.15859",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4043",
  "magpie-lib": "/magpie-lib/static-1.5484",
  "magpie-types": "/magpie-types/static-1.4944",
  "media-bridge-lib": "/media-bridge-lib/static-1.18730",
  "video-data-lib": "/video-data-lib/static-1.34555",
  "commerce-products-lib": "/commerce-products-lib/static-1.9117",
  "crm-message-bus": "/crm-message-bus/static-1.42654",
  "growth-data-modal": "/growth-data-modal/static-1.5258",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4769",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4612",
  "calling-global-api": "/calling-global-api/static-1.64058",
  "calling-internal-common": "/calling-internal-common/static-1.31192",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65440",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57734",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3707",
  "crm-links": "/crm-links/static-1.6165",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12908",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7973",
  "external-options-client-types": "/external-options-client-types/static-1.4068",
  "file-manager-components": "/file-manager-components/static-1.23252",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6766",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.26",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3499",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4132",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.521",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3599",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48348",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3874",
  "property-value-citations": "/property-value-citations/static-1.1747",
  "pulse": "/pulse/static-1.424",
  "smart-property-lib": "/smart-property-lib/static-1.6382",
  "tiered-pricing": "/tiered-pricing/static-1.994",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10882",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2962",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1572",
  "navigation-components": "/navigation-components/static-1.17611",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.464",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7418",
  "ui-universal-auth": "/ui-universal-auth/static-1.8821",
  "batch-promise": "/batch-promise/static-1.1442",
  "navigation-messaging": "/navigation-messaging/static-1.6938",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17283",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9704",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4912",
  "audio-components": "/audio-components/static-1.5749",
  "FileManagerCore": "/FileManagerCore/static-1.38751",
  "FileManagerImages": "/FileManagerImages/static-1.36403",
  "video-components": "/video-components/static-1.12900",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.725",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4391",
  "nav-client-types": "/nav-client-types/static-1.2248",
  "purchase-motions-api": "/purchase-motions-api/static-1.5664",
  "self-service-api": "/self-service-api/static-1.10136",
  "signup-constants": "/signup-constants/static-1.18635",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7930",
  "trials-service-types": "/trials-service-types/static-1.3792",
  "usage-tracker-public": "/usage-tracker-public/static-1.7037",
  "chatspot-core": "/chatspot-core/static-1.20767",
  "ContentUtils": "/ContentUtils/static-1.67981",
  "copilot-toolkit": "/copilot-toolkit/static-1.10807",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6471",
  "reactive-lib": "/reactive-lib/static-1.614",
  "simple-logging-lib": "/simple-logging-lib/static-1.2941",
  "commerce-permissions": "/commerce-permissions/static-1.655",
  "customer-data-tracking": "/customer-data-tracking/static-1.6773",
  "products-iframe-lib": "/products-iframe-lib/static-1.7605",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10088",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1774",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.228",
  "calling-error-reporting": "/calling-error-reporting/static-1.31198",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10929",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6432",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.551",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7139",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8871",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4052",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3918",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6671",
  "persist-promise": "/persist-promise/static-1.3599",
  "directed-graph": "/directed-graph/static-1.828",
  "event-emitter": "/event-emitter/static-1.838",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.16",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9789",
  "fsm": "/fsm/static-1.3624",
  "policy-lib": "/policy-lib/static-1.6673",
  "react-tinymce": "/react-tinymce/static-1.54905",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9852",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54031",
  "tinymce-plugins": "/tinymce-plugins/static-1.57145",
  "tinymce-themes": "/tinymce-themes/static-1.56001",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1600",
  "user-context-client": "/user-context-client/static-1.4502",
  "nest": "/nest/static-1.112",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.616",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4422",
  "video-embed": "/video-embed/static-1.35389",
  "content-icons-ui": "/content-icons-ui/static-1.2196",
  "social-insights-client-types": "/social-insights-client-types/static-1.21727",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3073",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4699",
  "integrations-lib": "/integrations-lib/static-1.15735",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4154",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14490",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35328",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3519",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4410",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2933",
  "interframe": "/interframe/static-3.4653",
  "tinymce-data": "/tinymce-data/static-1.40116",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5102",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12229",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11204",
  "react-codemirror": "/react-codemirror/static-1.10514",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14698",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8978",
  "outpost": "/outpost/static-1.4085",
  "flux-actions": "/flux-actions/static-1.323",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13150",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5486",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7677",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10264",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.335",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68056",
  "layout-data-lib": "/layout-data-lib/static-1.9529",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2897",
  "advanced-menus-core": "/advanced-menus-core/static-1.14956",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11920",
  "ExportDialog": "/ExportDialog/static-6.10280",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33720",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14955",
  "simple-menus-lib": "/simple-menus-lib/static-1.16472"
}
};
